
































































import { Filters } from "@/common/filters.global";
import { uniq } from "@/fp";
import { computed } from "@vue/composition-api";
import Vue from "vue";
import { BaseAppScript } from "./data/models";
export default Vue.extend({
  props: ["item"],
  setup(props) {
    const threats = computed(() => {
      const item = props.item as BaseAppScript;
      const { cascading_threats, threats } = item;
      return uniq([...threats, ...cascading_threats]);
    });

    const display_desc = computed(() => {
      const item = props.item as BaseAppScript;
      return Filters.ellipsis(item.description, 340);
    });
    return { threats, display_desc };
  },
});
